import TransferOwnership from './TransferOwnership'
export default TransferOwnership
